module.exports =
  loadSettings: (key) ->
    # TODO
    # promise = $.Deferred()
    # promise.reject({})
    # promise
    Promise.reject({})
